/**
 * The form field that opens the picker (the prototype's `DigesterIcons.field`): label, a hidden input
 * carrying the value (so plain forms still read it), and a trigger showing the current glyph and name.
 * Used by Topics, Folders, Tags, Filters and Views.
 */

import { useState } from 'react';
import { Icon } from './Icon.js';
import { IconPicker } from './IconPicker.js';
import { iconLabel, resolveIcon } from './registry.js';

export interface IconFieldProps {
  label: string;
  name: string;
  value: string;
  onChange(name: string): void;
}

export function IconField({ label, name, value, onChange }: IconFieldProps) {
  const [open, setOpen] = useState(false);
  const selected = resolveIcon(value) ?? value;
  return (
    <label className="field di-field">
      <span>{label}</span>
      <input type="hidden" name={name} value={value} />
      <button
        type="button"
        className="di-trigger"
        data-di-trigger=""
        aria-label={`${label}: ${iconLabel(selected)}. Choose icon`}
        aria-haspopup="dialog"
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
      >
        <Icon name={selected} />
        <span>{iconLabel(selected)}</span>
        <Icon name="chevron-down" />
      </button>
      {open && (
        <IconPicker
          value={value}
          onChoose={(chosen) => {
            setOpen(false);
            onChange(chosen);
          }}
          onClose={() => setOpen(false)}
        />
      )}
    </label>
  );
}
